import { createRoute } from "../lib/createRoute";
import About from "../pages/About";

export const Route = createRoute(
  "/about",
  About,
  "About Flowstep: Our AI Design Tool",
  "Meet the team building Flowstep, the AI design tool for product teams. Our mission is to democratize design so everyone can turn ideas into polished UI.",
);
